import { Model } from '@appstrax/services/database';
import { OrgUserRoles } from '@models';
import type { InviteStatus } from './project-invite.model';
import { ProjectUserRoles } from './many-to-many.model';

export class OrganizationInvite extends Model {
  public organizationId: string = '';
  public fromUserId: string = '';
  public toUserId: string = '';
  public role: OrgUserRoles = OrgUserRoles.USER;
  /**
   * Optional: include projectIds so accepting the org invite also grants project access.
   * This enables "bulk invite to org + selected projects" without email.
   */
  public projectIds: string[] = [];
  public projectRole: ProjectUserRoles = ProjectUserRoles.MEMBER;
  public status: InviteStatus = 'pending';
  public timestamp: number = Date.now();
  public note?: string;
}

